/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { useDispatch, useSelector } from "react-redux";
import LoadPanel from "devextreme-react/load-panel";
import { formatMessage } from "devextreme/localization";
import notify from "devextreme/ui/notify";
import DataGrid, {
  Column,
  Paging,
  Selection,
  FilterRow,
} from "devextreme-react/data-grid";
import { ScrollView } from "devextreme-react/scroll-view";
import {
  showAnnouncementUser,
  showAnnouncement,
  showUser,
  IsPermisionOidRequired,
} from "../../../../redux/actions";
import {
  responseAnnouncement,
  responseAnnouncementUser,
  responseUser,
  responseMiddleware,
} from "../../../../redux/reducers";
import PopupConfig from "../../../../common/popup";
import AnnouncementUserTableList from "./AnnouncementUserTable";
import UsingIntl from "../../../../services/using_intl";
// import "../style.scss";

export default function AnnouncementUserPage() {
  const [selectedItemKeys, setSelectedItemKeys] = useState([]);
  const [selectedItemKeysPopup, setSelectedItemKeysPopup] = useState([]);
  const [selectedBox, setSelectedBox] = useState("");

  const dispatch = useDispatch();
  let dataGrid = useRef(null);
  const history = useHistory();

  const { announcement } = useSelector(responseAnnouncement);
  const { user } = useSelector(responseUser);
  const { announcementUser } = useSelector(responseAnnouncementUser);
  const { middleware, loading } = useSelector(responseMiddleware);
  const { handleOpenPopup, handleClosePopup, popupConfig } = PopupConfig();

  useEffect(() => {
    UsingIntl();
    dispatch(IsPermisionOidRequired());
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }
      dispatch(showAnnouncement());
      dispatch(showUser());
    }
  }, [middleware]);

  const handleChangeSelectBox = ({ value }) => {
    setSelectedBox(value._value);
    dispatch(showAnnouncementUser(value._value));
  };

  const handleSelectionPopupChanged = ({ selectedRowsData }) => {
    setSelectedItemKeysPopup(selectedRowsData);
  };

  const handleSubmitPopup = async () => {
    const data = {
      Announcement: { Oid: selectedBox },
      User: { Oid: selectedItemKeysPopup[0].Oid },
    };
    if (!selectedItemKeysPopup[0].Oid) {
      notify("Please select a user", "error", 3000);
    }
    announcementUser.store().insert(data);
    handleClosePopup();
    dataGrid.current.instance.refresh();
  };

  const handleDeleteRecords = () => {
    selectedItemKeys.forEach((key) => {
      announcementUser.store().remove(key);
    });
    setSelectedItemKeys({
      selectedItemKeys: [],
    });
    announcementUser.reload();
  };

  const renderPopup = () => {
    return (
      <Popup
        visible={popupConfig.popupVisible}
        onHiding={handleClosePopup}
        title={formatMessage("AddAnnouncementUser")}
        borderRadius={10}
        closeOnOutsideClick={false}
      >
        <ScrollView width="100%" height="100%">
          <DataGrid
            id="gridContainer2"
            dataSource={user}
            keyExpr="Oid"
            showBorders={true}
            // selectedRowKeys={selectedItemKeysPopup}
            onSelectionChanged={handleSelectionPopupChanged}
          >
            <FilterRow visible={true} />
            <Paging enabled={true} />
            <Selection
              mode="multiple"
              selectAllMode="page"
              showCheckBoxesMode="always"
            />
            <Column dataField="UserName" caption={formatMessage("Username")} />
            <Column
              dataField="Employee.FullName"
              caption={formatMessage("FullName")}
            />
            <Column
              dataField="Employee.Department.DepartmentName"
              caption={formatMessage("Department")}
              allowEditing={false}
            />
            <Column
              dataField="Employee.Position.PositionName"
              caption={formatMessage("Position")}
              allowEditing={false}
            />
          </DataGrid>
        </ScrollView>
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          // disabled={selectedItemKeysPopup[0].Oid ? true : false}
          location="after"
          onClick={handleSubmitPopup}
          options={{
            icon: "save",
            type: "default",
            text: formatMessage("Save"),
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleClosePopup}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Close"),
          }}
        />
      </Popup>
    );
  };

  const handleSelectionChanged = ({ selectedRowKeys }) => {
    setSelectedItemKeys(selectedRowKeys);
  };

  return (
    <div>
      <LoadPanel visible={loading} />
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("AnnouncementUser")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/Default" className={"breadcrumb-item"}>
            {formatMessage("Default")}
          </Link>

          <span className={"breadcrumb-item active"}>
            {formatMessage("AnnouncementUser")}
          </span>
        </div>
      </div>
      <div className={"section"}>
        <div className={"section-body"}>
          {popupConfig.popupVisible && renderPopup()}

          <AnnouncementUserTableList
            dataGrid={dataGrid}
            announcementUser={announcementUser}
            announcement={announcement}
            selectedItemKeys={selectedItemKeys}
            selectedBox={selectedBox}
            middleware={middleware}
            onSelectionChanged={handleSelectionChanged}
            onOpenPopup={handleOpenPopup}
            onChangeSelectBox={handleChangeSelectBox}
            onDeleteRecords={handleDeleteRecords}
          />
        </div>
      </div>
    </div>
  );
}
